const minDesktop = 1024;

export default {
  desktop: {
    minWidth: minDesktop,
    maxWidth: null,
  },

  mobile: {
    minWidth: null,
    maxWidth: minDesktop - 1,
  },
};
